/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewEnumerationRecord
 */
export interface CRSFSecReviewEnumerationRecord {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewEnumerationRecord
     */
    answers: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewEnumerationRecord
     */
    ts?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewEnumerationRecord
     */
    type: string;
}

/**
 * Check if a given object implements the CRSFSecReviewEnumerationRecord interface.
 */
export function instanceOfCRSFSecReviewEnumerationRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "answers" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function CRSFSecReviewEnumerationRecordFromJSON(json: any): CRSFSecReviewEnumerationRecord {
    return CRSFSecReviewEnumerationRecordFromJSONTyped(json, false);
}

export function CRSFSecReviewEnumerationRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewEnumerationRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answers': json['answers'],
        'ts': !exists(json, 'ts') ? undefined : json['ts'],
        'type': json['type'],
    };
}

export function CRSFSecReviewEnumerationRecordToJSON(value?: CRSFSecReviewEnumerationRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answers': value.answers,
        'ts': value.ts,
        'type': value.type,
    };
}

